/// https://github.com/remarkjs/react-markdown
// https://github.com/rexxars/react-markdown-examples
import type { ComponentPropsWithoutRef } from "react";
import { isValidElement } from "react";
import { PropsWithChildren } from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Link } from "react-router-dom";

interface aGroupProps extends ComponentPropsWithoutRef<"a"> {
    href: string;
}

function CustomTwitterComponent({ url }: { url: string }) {
    return <span>{url}</span>;
}

function RouterLink({ href, ...rest }: aGroupProps) {
    return href.match(/^(https?:)?\/\//) ? (
        <a href={href}>{"props.children"}</a>
    ) : (
        <Link to={href}>{"props.children"}</Link>
    );
}

/*
function MDLink({href, children, ...props}: Markdown.Component) {
	return (
		<span>this</span>
	)
}
// */

/*
function linkISExternal(link: string) {
		return (link.host !== window.location.host)
}
// */

function mapPage(p: string): string {
    if (p === "logs") {
        return "page";
    } else if (p === "projects" || p === "tasks") {
        return "ticket";
    } else {
        return p;
    }
}

function linkRmBase(link: string) {
    var pathname = new URL(link).pathname;
    return pathname;
}
interface hrefResult {
    routerLink: boolean;
    href: string;
    target: string;
}

function processLink(href: string): hrefResult {
    if (href[0] === "?" || href[0] === "/") {
        var split = href.split(/[&?]/);
        let p = null;
        let action = "view";
        let id = null;
        for (var i = 0; i < split.length; i++) {
            if (split[i].startsWith("p=")) {
                p = split[i].substr(2);
            } else if (split[i].startsWith("action=")) {
                action = split[i].substr(7);
            } else if (split[i].startsWith("id=")) {
                //console.log("split: " + split[i]);
                id = split[i].substr(3);
            }
        }
        /*
		let res;
		if (p && action && id) {
			console.log("p action id:", p, action, id);
			res = {
			   	routerLink: true,
			   	href: '/' + p + '/' + action + '/' + id,
				target: "_self",
			}
		} else {
			console.log("202409051003", href);
			res = {
			   	routerLink: true,
			   	href: href,
				target: "_blank",
			}
		}
		// */
        return {
            routerLink: true,
            href:
                p && action && id
                    ? "/" + mapPage(p) + "/" + action + "/" + id
                    : href,
            target: "_self",
        };
    }
    return {
        routerLink: false,
        href: href,
        target: "_blank",
    };
}

const str = `
**mouais**

azer

- [old link](?p=logs&id=255)
- [new link](/page/view/255)
- [lalibre](http://www.lalibre.be)
`;

export default function MDViewer({ md }: { md: string }) {
    return (
        <div className="markdown-body">
            <Markdown
                remarkPlugins={[remarkGfm]}
                components={{
                    a: ({ href, children, ...props }) => {
                        if (href) {
                            let hrefR = processLink(href);
                            if (hrefR.routerLink) {
                                return <Link to={hrefR.href}>{children}</Link>;
                            } else {
                                return (
                                    <a href={hrefR.href} target={hrefR.target}>
                                        {children}
                                    </a>
                                );
                            }
                        } else {
                            return <span>problem w/ link</span>;
                        }
                    },
                    /*
				pre: ({ children }) => {
					if (isValidElement(children)) {
						const {
							node,
							className,
							children: innerChildren,
							ref,
							...props
						} = children.props;

						console.log(props);

						return <>{"arf"}</>;
					}
				},
                // */
                }}
            >
                {md}
            </Markdown>
        </div>
    );
}
